import { defineStyleConfig } from "@chakra-ui/react";

const Switch = defineStyleConfig({
  baseStyle: {
    track: {
      bg: "secondary.300",
      _checked: {
        bg: "primary.300",
      },
    },
  },
});

export default Switch;
